import { ASPECT_RATIO_VALIDATION_MESSAGE, MAX_DIMENSION_VALIDATION_MESSAGE } from '../_context/constants';

const MAX_ASPECT_RATIO = 2;
const MAX_DIMENSION_PX = 8000;

export type ImageDimensionError = 'aspect_ratio' | 'max_dimension';

export function validateImageDimensions(file: File): Promise<ImageDimensionError | null> {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = (): void => {
            const { naturalWidth, naturalHeight } = img;
            URL.revokeObjectURL(img.src);

            if (naturalWidth > MAX_DIMENSION_PX || naturalHeight > MAX_DIMENSION_PX) {
                resolve('max_dimension');
                return;
            }

            const longer = Math.max(naturalWidth, naturalHeight);
            const shorter = Math.min(naturalWidth, naturalHeight);
            if (shorter === 0 || longer / shorter > MAX_ASPECT_RATIO) {
                resolve('aspect_ratio');
                return;
            }

            resolve(null);
        };
        img.onerror = (): void => {
            URL.revokeObjectURL(img.src);
            resolve(null);
        };
        img.src = URL.createObjectURL(file);
    });
}

export function dimensionErrorToMessage(error: ImageDimensionError): string {
    return error === 'max_dimension' ? MAX_DIMENSION_VALIDATION_MESSAGE : ASPECT_RATIO_VALIDATION_MESSAGE;
}
